<template>
	<div class="patient_list">
		<div class="module-title">已绑定患者</div>
		<div class="patient_list_body">
			<base-list-item
				v-for="item in list"
				:key="item.id"
				type="primary"
				hide-checked
				:user-name="item.name"
				:gender="$status.gender[item.gender]"
				:age="item.age"
				:tag="$status.relation[item.relation]"
			/>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'patient-list',
		data: () => ({
			loading: false,
			list: []
		}),
		mounted () {
			this.getPatientList()
		},
		methods: {
			getPatientList () {
				this.loading = true
				this.$api.patient.getPatientList().then(res => {
					this.loading = false
					if (!res.code) {
						this.list = res.data
						this.$emit('onPatientList', res.data)
					}
				}).catch(() => this.loading = false)
			}
		}
	};
</script>

<style scoped lang="less">
	.patient_list {
		.patient_list_body {
			margin-top: 40px;
			>div + div{ margin-top: 28px; }
		}
	}
</style>
